import { MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS } from "@editor/modules/media-lib/constants";
import { cn } from "@lib/cn";
import { FontFileIcon } from "@/shared/icons";

interface IProps {
  isSelected?: boolean;
  fileName: string;
}

export const MediaLibFileFont = ({ isSelected, fileName }: IProps) => {
  return (
    <div
      style={{ height: MEDIA_LIB_DIALOG_MASONRY_SKELETON_HEIGHTS[0][0] }}
      className={cn(
        "tw-grid tw-place-items-center tw-rounded tw-outline tw-outline-1 -tw-outline-offset-1 tw-transition-[outline-color] hover:tw-outline-primary",
        isSelected
          ? "tw-outline-offset-1 tw-outline-primary"
          : "tw-outline-primary/20",
      )}
    >
      <FontFileIcon />
      <div
        className="tw-absolute tw-bottom-0 tw-left-0 tw-z-10 tw-flex tw-h-full tw-w-full tw-items-end tw-rounded-b tw-px-1 tw-pb-2 tw-opacity-0 tw-transition-opacity group-hover:tw-opacity-100"
        style={{
          background:
            "linear-gradient(0deg, #0D0D0D 9%, rgba(13, 13, 13, 0.00) 100%)",
        }}
      >
        <span className="tw-block tw-truncate tw-text-[10px] tw-font-semibold !tw-text-white tw-underline visited:tw-text-white hover:tw-text-white active:tw-text-white">
          {fileName}
        </span>
      </div>
    </div>
  );
};
